// All player-facing strings (GDD §0.2). UI code must use t('key'), never literals.

export const en = {
  'game.title': 'GLORP BATTLE',
  'title.play': 'Play',
  'title.subtitle': 'Battle prototype',
  'title.hintKeys': 'Keys: WASD move, Space chip, Esc pause',
  'title.hintTerminal': 'Roll NAVIGATION to move. Tap it to use the next chip.',
  'banner.gameOver': 'GAME OVER',
  'banner.paused': 'PAUSED',
  'banner.runClear': 'TERMINAL CLEAR!',
  'banner.wave': 'Wave {n}',
  'path.title': 'STEP {n}/{total}',
  'path.normal': 'Battle x{n}',
  'path.elite': 'Elite x{n}',
  'path.fight': 'Fight',
  'btn.abandon': 'Abandon run',
  'btn.title': 'Title',
  'btn.resume': 'Resume',
  'btn.debug': 'DBG',
  'tutorial.title': 'TUTORIAL',
  'tutorial.complete.title': 'TUTORIAL CLEAR',
  'tutorial.complete.hint': 'YOU KNOW THE BASICS',
  // Tutorial callouts (GDD §10.5): big 3D words, `terminal/bannerFont.ts` needs a glyph for each letter.
  'tutorial.move': 'MOVE',
  'tutorial.select': 'SELECT',
  'tutorial.selectTwo': 'SELECT TWO',
  'tutorial.attack': 'ATTACK',
  'tutorial.again': 'AGAIN',
  'result.step': 'Step',
  'result.hits': 'Hits taken',
  'result.hp': 'HP left',
  'result.total': 'Total time',
  'result.battles': 'Battles',
  'result.hpNow': 'HP',
  'result.folder': 'Folder',
  // `.brief`: what the chip does, for the 14-segment display; power is appended (GDD §6.5).
  'chip.cannon.name': 'Cannon',
  'chip.cannon.desc': 'Hits the first enemy in your lane.',
  'chip.cannon.brief': 'LINE HIT',
  'chip.sword.name': 'Sword',
  'chip.sword.desc': 'Slashes the panel in front of you.',
  'chip.sword.brief': 'FRONT CUT',
  'chip.widesword.name': 'WideSword',
  'chip.widesword.desc': 'Slashes the whole row in front of you.',
  'chip.widesword.brief': 'WIDE CUT',
  'chip.airshot.name': 'AirShot',
  'chip.airshot.desc': 'Hits the first enemy in your lane and pushes it back.',
  'chip.airshot.brief': 'PUSH SHOT',
  'chip.mine.name': 'Mine',
  'chip.mine.desc': 'Arms the panel three cells ahead until something enters it.',
  'chip.mine.brief': 'MINE 3 AHEAD',
  'chip.block.name': 'Block',
  'chip.block.desc': 'Places a temporary obstacle in front of you.',
  'chip.block.brief': 'WALL AHEAD',
  'chip.break.name': 'Break',
  'chip.break.desc': 'Temporarily breaks the panel three cells ahead.',
  'chip.break.brief': 'CRACK 3 AHEAD',
  'chip.spreader.name': 'Spreader',
  'chip.spreader.desc': 'Hits an enemy and the panels to either side.',
  'chip.spreader.brief': 'SPLASH HIT',
  'chip.guard.name': 'Guard',
  'chip.guard.desc': 'Blocks the next damaging hit.',
  'chip.guard.brief': 'BLOCK 1 HIT',
  'chip.areagrab.name': 'Area Grab',
  'chip.areagrab.desc': 'Takes the free panels of the nearest enemy row for a while.',
  'chip.areagrab.brief': 'STEAL ROW',
  'enemy.mettik': 'Mettik',
  'enemy.canodron': 'Canodron',
  'enemy.hopzap': 'Hopzap',
  'enemy.bladdy': 'Bladdy',
  'enemy.punchy': 'Punchy',
  // Battle log on the 14-segment display (GDD §7.2); `{chip}` is `BRIEF POWER`.
  'log.queued': '+ {chip}',
  'log.used': '> {chip}',
  'log.damage': '{name} -{n}',
  'log.you': 'You',
  'log.killed': '{name} down',
  'log.combo': 'Combo x{n}',
  'log.comboOk': 'Combo OK',
  'log.comboBreak': 'Combo break',
  'log.wave': 'Wave {n}',
  'log.waveClear': 'Wave clear',
} as const;

export type StringKey = keyof typeof en;
